<div class="hierarchical-filters">
	<div *ngIf="showDistributor" class="scope-select-wrapper">
		<label class="scope-select-label">Partner</label>
		<kt-searchable-select
			#distributorSelect
			[options]="distributorOptions$ | async"
			placeholder="All Partners"
			searchPlaceholder="Search partners..."
			[(ngModel)]="selectedDistributors"
			(selectionChange)="onDistributorChange($event)"
			(dropdownOpen)="onDropdownOpen(distributorSelect)"
			(dropdownClose)="onDropdownClose()"
			[disabled]="disabled"
			[multiple]="multiple"
			[displayValueFn]="getDistributorDisplay">
		</kt-searchable-select>
	</div>

	<div *ngIf="showMarket" class="scope-select-wrapper">
		<label class="scope-select-label">Market</label>
		<kt-searchable-select
			#marketSelect
			[options]="marketOptions$ | async"
			placeholder="All Markets"
			searchPlaceholder="Search markets..."
			[(ngModel)]="selectedMarkets"
			(selectionChange)="onMarketChange($event)"
			(dropdownOpen)="onDropdownOpen(marketSelect)"
			(dropdownClose)="onDropdownClose()"
			[disabled]="disabled || !hasDistributor"
			[loading]="loadingMarkets"
			[multiple]="multiple"
			[displayValueFn]="getMarketDisplay">
		</kt-searchable-select>
	</div>

	<div *ngIf="showClient" class="scope-select-wrapper">
		<label class="scope-select-label">Client</label>
		<kt-searchable-select
			#clientSelect
			[options]="clientOptions$ | async"
			placeholder="All Clients"
			searchPlaceholder="Search clients..."
			[(ngModel)]="selectedClients"
			(selectionChange)="onClientChange($event)"
			(dropdownOpen)="onDropdownOpen(clientSelect)"
			(dropdownClose)="onDropdownClose()"
			[disabled]="disabled"
			[loading]="loadingClients"
			[multiple]="multiple"
			[displayValueFn]="getClientDisplay">
		</kt-searchable-select>
	</div>

	<div *ngIf="showCampus" class="scope-select-wrapper">
		<label class="scope-select-label">Campus</label>
		<kt-searchable-select
			#campusSelect
			[options]="campusOptions$ | async"
			placeholder="All Campuses"
			searchPlaceholder="Search campuses..."
			[(ngModel)]="selectedCampuses"
			(selectionChange)="onCampusChange($event)"
			(dropdownOpen)="onDropdownOpen(campusSelect)"
			(dropdownClose)="onDropdownClose()"
			[disabled]="disabled"
			[loading]="loadingCampuses"
			[multiple]="multiple"
			[displayValueFn]="getCampusDisplay">
		</kt-searchable-select>
	</div>

	<div *ngIf="showMachine" class="scope-select-wrapper">
		<label class="scope-select-label">Machine</label>
		<kt-searchable-select
			#machineSelect
			[options]="machineOptions$ | async"
			placeholder="All Machines"
			searchPlaceholder="Search machines..."
			[(ngModel)]="selectedMachines"
			(selectionChange)="onMachineChange($event)"
			(dropdownOpen)="onDropdownOpen(machineSelect)"
			(dropdownClose)="onDropdownClose()"
			[disabled]="disabled"
			[loading]="loadingMachines"
			[multiple]="multiple"
			[displayValueFn]="getMachineDisplay">
		</kt-searchable-select>
	</div>

	<button *ngIf="hasAnySelection && hasVisibleFilters" type="button" class="clear-scope-btn" (click)="clearScope()">
		Clear scope
	</button>
</div>


